<template>
  <div class="lawoffLocfir">
    <div class="locfirtitle between">
      <div class="lt1">合肥律所</div>
      <div class="rm2">更多 ></div>
    </div>
    <div class="locfirlist">
      <div class="locfiritem flex_start" v-for="item in 5" :key="item">
        <div class="cover">
          <img src="../../../assets/findlawchild/locfircover.png" alt="" />
        </div>
        <div class="Lawfirms">
          <div class="name">安徽XXX律师事务所</div>
          <div class="zhuren">主任律师：王XX</div>
          <div class="yg">
            <span>业务领域：综合咨询</span>
            <span>团队规模 ：<span class="re">86</span>人</span>
          </div>
          <div class="adress">所在地址：合肥市蜀山区长江西路</div>
          <div class="shouxia flex_start">
            <span>旗下律师：</span>
            <img
              v-for="(i, j) in 5"
              :key="j"
              src="../../../assets/base/small_rentou.png"
              alt=""
            />
            <img src="../../../assets/findlawchild/locfirgengduo.png" />
          </div>
          <div class="lianxi">联系律所</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.lawoffLocfir {
  .locfirtitle {
    padding: 24px;
    border-bottom: 1px solid #eeeeee;
    .lt1 {
      font-size: 24px;
      color: #333333;
    }
    .rm2 {
      font-size: 16px;
      color: #999999;
      cursor: pointer;
    }
  }
  .locfirlist {
    .locfiritem {
      padding: 24px 32px;
      border-bottom: 1px solid #eee;
      position: relative;
      align-items: flex-start;
      .cover {
        margin-right: 37px;
        img {
          width: 256px;
          height: 170px;
        }
      }
      .Lawfirms {
        .name {
          font-size: 20px;
          color: #333333;
          line-height: 20px;
        }
        .zhuren {
          margin-top: 20px;
          font-size: 16px;
          color: #333333;
          line-height: 20px;
        }
        .yg {
          margin-top: 18px;
          font-size: 12px;
          color: #999999;
          line-height: 12px;
          > span {
            margin-right: 20px;
          }
          .re {
            color: #e30000;
          }
        }
        .adress {
          margin-top: 13px;
          font-size: 12px;
          color: #999999;
          line-height: 12px;
        }
        .shouxia {
          margin-top: 12px;
          font-size: 12px;
          color: #999999;
          span {
            margin-right: 10px;
          }
          img {
            cursor: pointer;
            width: 36px;
            height: 36px;
            border-radius: 50%;
            margin-right: 6px;
          }
        }
        .lianxi {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          text-align: center;
          right: 32px;
          width: 110px;
          height: 36px;
          line-height: 36px;
          background: #ffffff;
          border: 1px solid #333333;
          border-radius: 18px;
          font-size: 16px;
          color: #333333;
          cursor: pointer;
        }
      }

      &:last-child {
        border-bottom: none;
      }
    }
  }
}
</style>